export default "__VITE_ASSET__C$V$9goj__"